import { Button, Col, Row } from 'antd';
import Card from 'antd/lib/card';
import Form from 'antd/lib/form';
import Spin from 'antd/lib/spin';
import { generalLanguageKeys } from 'config/consts';
import { crudService, routerService } from 'core/services';
import { formService } from 'core/services/FormService';

import { API_MENU_REPORT_ROUTE } from 'config/api-consts';
import { FileTemplateFilter } from 'models/FileTemplateFilter';
import { MenuReport } from 'models/MenuReport';
import { join } from 'path';
import React from 'react';
import { useTranslation } from 'react-i18next';
import nameof from 'ts-nameof.macro';
import { menuReportRepository } from '../MenuReportRepository';
import FileTemplateTable from './FileTemplateTable/FileTemplateTable';
import './MenuReportDetail.scss';
import { Helmet } from 'react-helmet';

const { Item: FormItem } = Form;

function MenuReportDetail() {
  const [translate] = useTranslation();

  // const { id } = useParams();
  // const { validAction } = crudService.useAction(
  //   'app-user',
  //   API_APP_USER_PORTAL_ROUTE,
  // );

  // Service goback
  const [handleGoBack] = routerService.useGoBack();

  // Hooks, useDetail, useChangeHandler
  const [
    menuReport,
    setMenuReport,
    loading,
    ,
    isDetail,
    handleSave,
  ] = crudService.useDetail(
    MenuReport,
    menuReportRepository.get,
    menuReportRepository.save,
  );

  const [filteTemplateFilter, setFileTemplateFilter] = React.useState<
    FileTemplateFilter
  >(new FileTemplateFilter());

  const variablesFileDownloadPath: string = React.useMemo<string>(() => {
    const menuReportId = menuReport.id;
    return join(
      '/' + API_MENU_REPORT_ROUTE,
      `/variables-file/download?id=${menuReportId}`,
    );
  }, [menuReport.id]);

  const downloadURI = React.useCallback(
    (uri: string, name: string = 'fileDownloaded') => () => {
      const link = document.createElement('a');
      link.setAttribute('download', name);
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    [],
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${menuReport?.menu?.name} detail - eProcurement Management`}</title>
      </Helmet>
      <div className="page detail-page menu-report_detail ">
        <Spin spinning={loading}>
          <Card
            title={
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start">
                  <button
                    className="btn btn-link btn-back"
                    onClick={handleGoBack}
                  >
                    <i className="fa fa-chevron-left"></i>
                  </button>
                  <div className="pt-1 pl-1">
                    {isDetail
                      ? translate('general.detail.title')
                      : translate(generalLanguageKeys.actions.create)}
                  </div>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-outline-primary float-right ml-2 mr-2"
                    onClick={handleGoBack}
                  >
                    <i className="fa mr-2 fa-times-circle" />
                    {translate(generalLanguageKeys.actions.cancel)}
                  </button>
                  {!isDetail && (
                    <button
                      className="btn btn-sm btn-primary float-right"
                      onClick={handleSave}
                    >
                      <i className="fa mr-2 fa-save" />
                      {translate(generalLanguageKeys.actions.save)}
                    </button>
                  )}
                  {isDetail && (
                    <button
                      className="btn btn-sm btn-primary float-right"
                      onClick={handleSave}
                    >
                      <i className="fa mr-2 fa-save" />
                      {translate(generalLanguageKeys.actions.save)}
                    </button>
                  )}
                </div>
              </div>
            }
          >
            <Form>
              <Row>
                <Col lg={6}>
                  <FormItem
                    validateStatus={formService.getValidationStatus<MenuReport>(
                      menuReport.errors,
                      nameof(menuReport.menu),
                    )}
                    help={menuReport.errors?.menu}
                  >
                    <span className="label-input ml-3">
                      {translate('menuReports.menu')}
                    </span>
                    <input
                      type="text"
                      defaultValue={menuReport?.menu?.name}
                      className="form-control form-control-sm"
                      disabled
                    />
                  </FormItem>
                </Col>

                <Col lg={6}>
                  <FormItem
                    validateStatus={formService.getValidationStatus<MenuReport>(
                      menuReport.errors,
                      nameof(menuReport.name),
                    )}
                    help={menuReport.errors?.name}
                  >
                    <span className="label-input ml-3">
                      {translate('menuReports.name')}
                    </span>
                    <input
                      type="text"
                      defaultValue={menuReport.name}
                      className="form-control form-control-sm"
                      disabled
                    />
                  </FormItem>
                </Col>

                <Col lg={6}>
                  <Button
                    className="btn btn-sm btn-outline-primary mt-3 "
                    // disabled={menuReport?.pageId == null}
                    onClick={downloadURI(variablesFileDownloadPath, 'fileName')}
                  >
                    <i className="fa mr-2 tio-download_to" />
                    {translate('menuReports.actions.export')}
                  </Button>
                </Col>
                <Col lg={6}></Col>
                <Col lg={24}>
                  <FileTemplateTable
                    model={menuReport}
                    setModel={setMenuReport}
                    field={'fileTemplates'}
                    filter={filteTemplateFilter}
                    setFilter={setFileTemplateFilter}
                  />
                </Col>
              </Row>
              <Row></Row>
            </Form>
          </Card>
        </Spin>
      </div>
    </>
  );
}

export default MenuReportDetail;
